var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_22057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2C24 0.89543 23.1046 0 22 0H2C0.89543 0 0 0.895431 0 2V22C0 23.1046 0.895431 24 2 24H22C23.1046 24 24 23.1046 24 22V2Z",
    fill: "#0E1396"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37968 9.28252H7.58735V19.6032H4.37968V9.28252ZM5.98402 4.15219C7.00968 4.15219 7.84302 4.98552 7.84302 6.01119C7.84302 7.03786 7.00968 7.87152 5.98402 7.87152C5.73684 7.8762 5.49121 7.83156 5.26149 7.7402C5.03176 7.64885 4.82256 7.51262 4.6461 7.33947C4.46964 7.16632 4.32947 6.95972 4.23378 6.73177C4.13809 6.50382 4.08881 6.25908 4.08881 6.01186C4.08881 5.76463 4.13809 5.51989 4.23378 5.29194C4.32947 5.06399 4.46964 4.8574 4.6461 4.68425C4.82256 4.5111 5.03176 4.37486 5.26149 4.28351C5.49121 4.19215 5.73684 4.14751 5.98402 4.15219ZM9.59935 9.28219H12.676V10.6925H12.7187C13.147 9.88119 14.1934 9.02586 15.7537 9.02586C19.0017 9.02586 19.6017 11.1635 19.6017 13.9425V19.6032H16.396V14.5842C16.396 13.3875 16.374 11.8479 14.7294 11.8479C13.0604 11.8479 12.804 13.1515 12.804 14.4979V19.6032H9.59902V9.28252L9.59935 9.28219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_22057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.70c28bf32f18c299132a9e96e95f3e74.svg";
export { ForwardRef as ReactComponent };